// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually
import React from 'react';

const IconFileUp = (props: React.SVGProps<SVGElement>) =>
  /*#__PURE__*/ React.createElement(
    'svg',
    {
      width: '42',
      height: '42',
      viewBox: '0 0 42 42',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M18.9 37.8h-8.4a4.2 4.2 0 0 1-4.2-4.2V8.4a4.2 4.2 0 0 1 4.2-4.2h18.9a4.2 4.2 0 0 1 4.2 4.2v11.55m-6.3 11.625 4.295-4.275m0 0L35.7 31.38M31.595 27.3v10.5',
      stroke: 'current',
      strokeWidth: '2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    })
  );

export { IconFileUp };
